module.exports = __webpack_public_path__ + "media/home/LancasterRedIcon-f0a6f191.png";